import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
  
  @media (max-width: 600px) {
    margin-bottom: 10px;
  }
`;

const ProductImageWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  background-color: #f8f8f8;
`;

const ProductImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const FallbackImage = styled.div`
  width: 100%;
  height: 300px;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 0.9em;
`;

const ProductInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  padding: 5px 0;
  
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 3px 0;
  }
`;

const ProductTitle = styled.h2`
  font-family: 'Catchy Mager', sans-serif;
  font-size: 0.85em;
  margin: 0;
  font-weight: 400;
  color: #000;
  text-align: left;
  transition: color 0.3s ease-in-out;
  
  @media (max-width: 600px) {
    font-size: 0.75em;
    margin-bottom: 2px;
  }
`;

const ProductPrice = styled.p`
  font-family: 'Catchy Mager', sans-serif;
  font-size: 0.85em;
  margin: 0;
  color: #000;
  text-align: right;
  transition: color 0.3s ease-in-out;
  
  @media (max-width: 600px) {
    font-size: 0.75em;
    text-align: left;
  }
`;

const CardWrapper = styled(Link)`
  text-decoration: none;

  &:hover ${ProductTitle},
  &:hover ${ProductPrice} {
    color: #543230;
  }
`;

const ProductCard = ({ id, image, title, price }) => (
  <CardWrapper to={`/product/${id}`}>
    <Card>
      <ProductImageWrapper>
        {image ? (
          <ProductImage
            src={image}
            alt={title}
            onError={(e) => (e.target.style.display = 'none')}
          />
        ) : (
          <FallbackImage>Image Not Available</FallbackImage>
        )}
      </ProductImageWrapper>
      <ProductInfo>
        <ProductTitle>{title}</ProductTitle>
        <ProductPrice>${parseFloat(price).toFixed(2)}</ProductPrice>
      </ProductInfo>
    </Card>
  </CardWrapper>
);

export default ProductCard;
